import React, { useState, useEffect } from "react";
import {
  MDBRow,
  MDBCol,
  MDBInput,
  MDBBtn,
  MDBBtnGroup,
  MDBIcon,
  MDBContainer,
} from "mdbreact";
/* import { MDBContainer, MDBRow, MDBCol, MDBInput, MDBBtn, MDBIcon
  ,MDBModal,MDBModalBody , MDBModalHeader, MDBModalFooter } from 'mdbreact'; */

import Axios from "axios";

import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import WarningBox from "../components/WarningBox";

import { toast, ToastContainer } from "mdbreact";

const AddEditOutsourcedItem = (props) => {
  const useMountEffect = (functionName) => useEffect(functionName, []);

  const bearer = {
    headers: {
      Authorization: "Bearer " + sessionStorage.getItem("hash"),
    },
  };
  const [frm, setValues] = useState({
    code: "",
    barcode: "",
    sku: "N/A",
    upc: "N/A",
    description: "",
    unitofmeasure: "N/A",
    deleted: false,
    seniordiscountable: false,
    pwddiscountable: false,
    usertoken: sessionStorage.getItem("msal.uc"),
    itemcategory: { value: "2", label: "Goods" },
    discountable: false,
    sellingprice: 0,
    brand: "N/A",
    generic: "OUTSOURCED",
    outsourced: true,
  });

  const [passwordShown, setPasswordShown] = useState(false);

  const [disabledClass, setDisabledClass] = useState(false);
  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };

  const updateField = (e) => {
    const target = e.target;

    let value = target.value;
    let name = target.id;

    if (target.type === "checkbox") {
      value = target.checked;

      setValues({ ...frm, [name]: value });
    } else {
      setValues({ ...frm, [name]: value });
    }
  };

  function submitHandler(event) {
    event.preventDefault();
    event.target.className += " was-validated";

    saveitem();
  }

  const [errorMessage, setErrorMessage] = useState("");

  const [modalWarning, showWarningBox] = useState(false);

  const toggleWarningBox = () => {
    showWarningBox(!modalWarning);
  };

  const loaditemdetails = () => {
    Axios.get(
      props.apiServer + "/loaditemdetails?acode=" + props.itemcode,
      bearer
    )
      .then((res) => {
        if (res.data !== "empty") {
          setValues({
            ...frm,
            code: props.itemcode,
            barcode: res.data.barcode,
            sku: res.data.sku,
            upc: res.data.upc,
            description: res.data.description,
            unitofmeasure: res.data.unitofmeasure,
            deleted: res.data.deleted,
            seniordiscountable: res.data.seniordiscountable,
            pwddiscountable: res.data.pwddiscountable,
            itemcategory: {
              value: res.data.itemcategorycode,
              label: res.data.itemcategory,
            },
            discountable: res.data.discountable,
            sellingprice: res.data.sellingprice,
            brand: res.data.brand,
            generic: res.data.generic,
          });
        } else {
          console.log("No record");
        }
      })

      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };

  const saveitem = () => {
    const data = frm;

    Axios.post(props.apiServer + "/saveitem", data, bearer)
      .then((res) => {
        if (res.data.status === "1") {
          setValues({ ...frm, code: res.data.code });
          toast.info(res.data.message, {
            closeButton: false,
          });
          if (props.quicktool === "yes") {
            props.toggleModal();
          } else if (props.quickadd === "yes") {
            props.toggleModal2();
          } else {
            props.refreshGrid();
          }
        } else {
          setErrorMessage(res.data.message);
          toggleWarningBox();
        }
      })
      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };

  const deleteitem = () => {
    const data = frm;

    Axios.post(props.apiServer + "/deleteitem", data, bearer)
      .then((res) => {
        if (res.data.status === "1") {
          props.refreshGrid();

          toast.info(res.data.message, {
            closeButton: false,
          });
        } else {
          setErrorMessage(res.data.message);
          toggleWarningBox();
        }
      })
      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };

  const handleChange = (objName) => (selOption) => {
    setValues({ ...frm, [objName]: selOption });
    if (selOption !== "3") {
      setDisabledClass(false);
    } else {
      setDisabledClass(true);
    }
  };

  const [itemcategoryoptions, setitemcategoryoptions] = useState([]);
  const getoutsourceditemcategoryoptions = () => {
    Axios.get(props.apiServer + "/getoutsourceditemcategoryoptions", bearer)
      .then((res) => {
        setitemcategoryoptions(res.data);
      })

      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };

  const [isAdmin, checkAdmin] = useState(0);

  function checkAdminAccess() {
    Axios.get(
      props.apiServer +
        "/getadminaccess?username=" +
        sessionStorage.getItem("msal.uc"),
      bearer
    )
      .then((res) => {
        checkAdmin(0);
        checkAdmin(res.data[0].isadmin);
      })

      .catch((error) => {
        console.log(error);
      });
  }

  useMountEffect(getoutsourceditemcategoryoptions);
  useMountEffect(loaditemdetails);

  return (
    <React.Fragment>
      <MDBContainer fluid>
        <MDBRow>
          <MDBCol>
            <form
              className="needs-validation"
              onSubmit={submitHandler}
              noValidate
            >
              <MDBRow hidden>
                <MDBCol md="10">
                  <MDBInput
                    value={frm.code}
                    id="code"
                    label="code"
                    required
                    onChange={updateField}
                  >
                    <div className="invalid-feedback">
                      This field is required!
                    </div>
                    <div className="valid-feedback"></div>
                  </MDBInput>
                </MDBCol>
              </MDBRow>

              {/* <MDBRow>
                <MDBCol md="10">
                  <MDBInput
                    autoFocus={true}
                    value={frm.barcode}
                    id="barcode"
                    label="Barcode"
                    required
                    onChange={updateField}
                  ></MDBInput>
                </MDBCol>
              </MDBRow> */}

              <MDBRow>
                <MDBCol md="8">
                  <label className="grey-text">
                    <small>&nbsp;Item Category</small>
                  </label>
                  <br />
                  <Select
                    placeholderText="Select Item Category"
                    isSearchable
                    value={frm.itemcategory}
                    onChange={handleChange("itemcategory")}
                    options={itemcategoryoptions}
                    required
                    // className={disabled}
                  />

                  <div className="invalid-feedback ">
                    This field is required!
                  </div>
                  <div className="valid-feedback"></div>

                  <br />
                </MDBCol>
              </MDBRow>

              <MDBRow hidden>
                <MDBCol md="10">
                  <MDBInput
                    value={frm.generic}
                    id="generic"
                    label="Generic (e.g., Engine Oil 1 Liter)"
                    required
                    onChange={updateField}
                  >
                    <div className="invalid-feedback">
                      This field is required!
                    </div>
                    <div className="valid-feedback"></div>
                  </MDBInput>
                </MDBCol>
              </MDBRow>
              <MDBRow hidden>
                <MDBCol md="10">
                  <MDBInput
                    value={frm.brand}
                    id="brand"
                    label="Brand (e.g., Pertua)"
                    required
                    onChange={updateField}
                  >
                    <div className="invalid-feedback">
                      This field is required!
                    </div>
                    <div className="valid-feedback"></div>
                  </MDBInput>
                </MDBCol>
              </MDBRow>

              <MDBRow>
                <MDBCol md="10">
                  <MDBInput
                    value={frm.description}
                    id="description"
                    label="Description"
                    required
                    onChange={updateField}
                  >
                    <div className="invalid-feedback">
                      This field is required!
                    </div>
                    <div className="valid-feedback"></div>
                  </MDBInput>
                </MDBCol>
              </MDBRow>

              <MDBRow hidden>
                <MDBCol md="10">
                  <MDBInput
                    value={frm.unitofmeasure}
                    id="unitofmeasure"
                    label="Unit of Measure (e.g., 1L, 500ML)"
                    required
                    onChange={updateField}
                  >
                    <div className="invalid-feedback">
                      This field is required!
                    </div>
                    <div className="valid-feedback"></div>
                  </MDBInput>
                </MDBCol>
              </MDBRow>
              <MDBRow>
                <MDBCol md="10">
                  <MDBInput
                    value={frm.sellingprice}
                    id="sellingprice"
                    label="Price"
                    type="number"
                    onChange={updateField}
                    disabled={disabledClass}
                  >
                    <div className="invalid-feedback">
                      This field is required!
                    </div>
                    <div className="valid-feedback"></div>
                  </MDBInput>
                </MDBCol>
              </MDBRow>
              <MDBRow hidden>
                <MDBCol md="12">
                  <MDBInput
                    id="discountable"
                    label="Discountable"
                    labelClass="font-weight-bold"
                    type="checkbox"
                    checked={frm.discountable}
                    onChange={updateField}
                  >
                    <div className="invalid-feedback">
                      This field is required!
                    </div>
                    <div className="valid-feedback"></div>
                  </MDBInput>
                </MDBCol>
              </MDBRow>
              {/* <MDBRow>
                <MDBCol md="12" className="ml-5">
                  <MDBInput
                    id="seniordiscountable"
                    label="Senior Discountable"
                    labelClass="font-weight-bold green-text"
                    type="checkbox"
                    checked={frm.seniordiscountable}
                    onChange={updateField}
                  >
                    <div className="invalid-feedback">
                      This field is required!
                    </div>
                    <div className="valid-feedback"></div>
                  </MDBInput>
                </MDBCol>
              </MDBRow> */}

              {/* <MDBRow>
                <MDBCol md="12" className="ml-5">
                  <MDBInput
                    id="pwddiscountable"
                    label="PWD Discountable"
                    labelClass="font-weight-bold green-text"
                    type="checkbox"
                    checked={frm.pwddiscountable}
                    onChange={updateField}
                  >
                    <div className="invalid-feedback">
                      This field is required!
                    </div>
                    <div className="valid-feedback"></div>
                  </MDBInput>
                </MDBCol>
              </MDBRow> */}
              <MDBRow hidden>
                <MDBCol md="12">
                  <MDBInput
                    id="deleted"
                    label="Deleted"
                    labelClass="font-weight-bold red-text"
                    type="checkbox"
                    checked={frm.deleted}
                    onChange={updateField}
                  >
                    <div className="invalid-feedback">
                      This field is required!
                    </div>
                    <div className="valid-feedback"></div>
                  </MDBInput>
                </MDBCol>
              </MDBRow>

              <MDBRow>
                <MDBCol md="6">
                  <MDBBtn className="blue lighten-1" type="submit">
                    Save
                  </MDBBtn>{" "}
                  {props.itemcode === "" && props.quickadd !== "yes" ? (
                    <MDBBtn
                      className="cloudy-knoxville-gradient blue-text"
                      onClick={props.toggleModal}
                    >
                      Close
                    </MDBBtn>
                  ) : (
                    ""
                  )}
                  {props.quicktool === "yes" ? (
                    <>
                      <MDBBtn
                        id="cmdClose"
                        className="blue lighten-4 blue-text"
                        onClick={props.toggleModal}
                      >
                        Close this
                      </MDBBtn>
                      <MDBBtn
                        id="cmdClose"
                        className="orange lighten-4 black-text"
                        onClick={props.toggleModal2}
                      >
                        Back to Receiving
                      </MDBBtn>
                    </>
                  ) : (
                    ""
                  )}
                  {props.quickadd === "yes" ? (
                    <>
                      <MDBBtn
                        id="cmdClose"
                        className="blue lighten-4 blue-text"
                        onClick={props.toggleModal2}
                      >
                        Close this
                      </MDBBtn>
                    </>
                  ) : (
                    ""
                  )}
                </MDBCol>
                <MDBCol md="6"></MDBCol>
              </MDBRow>
            </form>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
      <ToastContainer
        hideProgressBar={true}
        newestOnTop={true}
        autoClose={5000}
      />

      <WarningBox
        errorMessage={errorMessage}
        isOpen={modalWarning}
        toggleModal={toggleWarningBox}
      />
      {/* <MessagePersonalInfo /> */}
    </React.Fragment>
  );
};
export default AddEditOutsourcedItem;
